import { default as olMousePosition } from 'ol/control/MousePosition.js';
import {Control} from '../Control.js';

export class MousePosition extends Control {

    constructor( map, settings = {} ){
        settings["name"] = 'mouse_position';
        if( settings['target'] == undefined ) settings['target'] = "mouse_position";
        if( settings['format'] == undefined ) settings['format'] = "deg";
        super( map, settings );
        this.getState();

        this.control = new olMousePosition({
                "target": this.target,
                "coordinateFormat": this.formatter.bind(this),
                "projection": 'EPSG:4326',
                "placeholder": "--"
                });
    }

    formatter(loc){
        let lat = loc[1];
        let lon = loc[0];
        while( lon < -180 ) lon += 360;
        while( lon > 180 ) lon -= 360;

        let str = "--";
        if( this.settings['format'] == "deg" )
            str = lat.toFixed(3) + "," + lon.toFixed(3);
        else if( this.settings['format'] == "dm" ){
            lat = Math.abs(lat);
            var l = "N";
            if( loc[1] < 0 ) l = "S";
            var d = Math.floor( lat );
            var m = Math.floor((lat-d)*60);
            var fm = Math.floor(((lat-d)*60-m)*100);
            str = ""+d+":"+m.toString().padStart(2,"0")+"."+fm.toString().padStart(2,"0")+l+",";

            var l = "E";
            if( lon < 0 ) l = "W";
            lon = Math.abs(lon);
            var d = Math.floor( lon );
            var m = Math.floor((lon-d)*60);
            var fm = Math.floor(((lon-d)*60-m)*100);
            str = str+d+":"+m.toString().padStart(2,"0")+"."+fm.toString().padStart(2,"0")+l;
        }
        else if( this.settings['format'] == "dms" ){
            lat = Math.abs(loc[1]);
            var l = "N";
            if( loc[1] < 0 ) l = "S";
            var d = Math.floor( lat );
            var m = Math.floor((lat-d)*60);
            var s = Math.floor(((lat-d)*60-m)*60);
            str = ""+d+":"+m.toString().padStart(2,"0")+":"+s.toString().padStart(2,"0")+l+",";

            var l = "E";
            if( lon < 0 ) l = "W";
            lon = Math.abs(lon);
            var d = Math.floor( lon );
            var m = Math.floor((lon-d)*60);
            var s = Math.floor(((lon-d)*60-m)*60);
            str = str+d+":"+m.toString().padStart(2,"0")+":"+s.toString().padStart(2,"0")+l;
        }
        return str;
    }
}
